module.exports = __webpack_public_path__ + "static/media/account.e2e761f1.svg";